import { useState } from "react";
import Swal from "sweetalert2";

const ProtectedResumeWrapper = ({ children }) => {
  const [authorized, setAuthorized] = useState(false);
  const [input, setInput] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (input === process.env.REACT_APP_GENRESUME || 'SuperSecretHunar@8850') {
      setAuthorized(true);
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Wrong Password.',
        text: "You can't access this page.",
        confirmButtonText: 'OK',
        confirmButtonColor: '#dc3545'
      })
    }
  };

  if (!authorized) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-50">
        <div className="card border-1 rounded-4" style={{ maxWidth: "400px", width: "100%" }}>
          <div className="card-body p-4">
            <h4 className="card-title text-center mb-4 fw-bold text-primary">
              🔐 Super Admin Access Required
            </h4>

            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label htmlFor="adminPassword" className="form-label fw-semibold">
                  Enter Password
                </label>
                <input
                  id="adminPassword"
                  type="password"
                  className="form-control"
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  placeholder="Enter admin password"
                />
              </div>

              <div className="d-grid">
                <button type="submit" className="btn btn-primary">
                  Unlock
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedResumeWrapper;
